@if (isHob) {
  <sd-header-with-tabs
    [tabsBrands]="activeBrands"
    [showPageNavigation]="showSticky"
    [deliveryContactData]="iconLabel"
    [dropdownAccountData]="dropDownAccountData"
    [dropdownHelpData]="dropdownHelpData"
    [dropdownCartData]="dropDownCart"
    [searchData]="searchData"
    [iconLinks]="headerIconLink"
    [menuDataConfig]="menuDataConfig"
    [languageSelectorData]="languageSelectorData"
    [logoLink]="logoLink"
    [pageNavigationData]="pageNavigationData"
    [inputMinLength]="inputMinLength"
    [isSimplified]="isSimplified"
    [isBundle]="isBundle"
    [discoverBrandsText]="discoverBrandsText"
    [activeBrand]="activeBrand"
    (searchElementClicked)="onSearchElementClicked($event)"
    (login)="login()"
    (signUp)="login()"
    (logout)="logout()"
    (languageSelected)="setLanguage($event)"
    (delete)="removeCartEntry($event)"
    (quantity)="changeQuantity($event)"
    (back)="checkoutPreviousStep()"
    (cart)="addToCartEntry()"
    (notify)="cartNotification()"
    (clearInputSearch)="onClearInputSearch()"
    (tabSelected)="onSelectHob($event)"
    (inputSearch)="search($event)"
    (submitSearch)="submitSearch($event)"
    (clickMenu)="onClickMenu($event)"
    (isAccountOpenedChange)="isAccountOpened($event)"
    (isCartOpenedChange)="isCartOpened($event)"
    (menuOpen)="manageOpenedMenu($event)"
    (scrolled)="onScrolled($event)"
    (empty)="openEmptyMinicartModal()"
    (promoClick)="onClickPromo($event)"
    (openRecommendedPriceModal)="openRecommendedPriceModal()"
    (pushCardClicked)="onPushCardClicked($event)"
    (linkClicked)="onLinkClicked($event)"
    (clickCardFrames)="onClickCardFrames($event)"
  />
} @else {
  <sd-header
    [alpha]="alpha"
    [themesConfig]="themesConfig"
    [showPageNavigation]="showSticky"
    [deliveryContactData]="iconLabel"
    [dropdownAccountData]="dropDownAccountData"
    [dropdownHelpData]="dropdownHelpData"
    [dropdownCartData]="dropDownCart"
    [searchData]="searchData"
    [iconLinks]="headerIconLink"
    [menuDataConfig]="menuDataConfig"
    [languageSelectorData]="languageSelectorData"
    [logoLink]="logoLink"
    [pageNavigationData]="pageNavigationData"
    [inputMinLength]="inputMinLength"
    [isSimplified]="isSimplified"
    [isBundle]="isBundle"
    (searchElementClicked)="onSearchElementClicked($event)"
    (login)="login()"
    (signUp)="login()"
    (logout)="logout()"
    (languageSelected)="setLanguage($event)"
    (delete)="removeCartEntry($event)"
    (quantity)="changeQuantity($event)"
    (back)="checkoutPreviousStep()"
    (cart)="addToCartEntry()"
    (notify)="cartNotification()"
    (clearInputSearch)="onClearInputSearch()"
    (inputSearch)="search($event)"
    (submitSearch)="submitSearch($event)"
    (clickMenu)="onClickMenu($event)"
    (isAccountOpenedChange)="isAccountOpened($event)"
    (isCartOpenedChange)="isCartOpened($event)"
    (menuOpen)="manageOpenedMenu($event)"
    (scrolled)="onScrolled($event)"
    (empty)="openEmptyMinicartModal()"
    (promoClick)="onClickPromo($event)"
    (openRecommendedPriceModal)="openRecommendedPriceModal()"
    (pushCardClicked)="onPushCardClicked($event)"
    (linkClicked)="onLinkClicked($event)"
    (clickCardFrames)="onClickCardFrames($event)"
  />
}

<sd-modal-default
  [(isOpened)]="isModalEmptyMinicartOpened"
  [modalTitle]="'cart.minicart.actions.empty' | translate"
  [modalTitleLevel]="6"
  [clickToClose]="true"
>
  <span sd-modal-body>{{ 'cart.minicart.actions.modalTitle' | translate }}</span>
  <div>
    <footer class="c__modal-actions" sd-modal-footer>
      <button sd-button (click)="isModalEmptyMinicartOpened = false" [isSecondary]="true">
        <span>{{ 'cart.minicart.actions.cancel' | translate }}</span>
      </button>
      <button sd-button (click)="emptyDropdownCart()">
        <span>{{ 'cart.minicart.actions.validate' | translate }}</span>
      </button>
    </footer>
  </div>
</sd-modal-default>

@if (logoutIframeOpened) {
  <iframe
    [hidden]="true"
    [attr.aria-hidden]="true"
    tabindex="-1"
    [src]="logoutIframeSrc"
    (load)="closeLogoutIframe()"
    title="Logout frame"
  ></iframe>
}

<wc-product-notification-modal
  [productCode]="notifyProduct"
  [productName]="notifyProductName"
  [(notifyModalOpened)]="notifyModalOpened"
/>

<wc-omnibus-recommended-price-modal
  [(isOpenedRecommendedPriceModal)]="isOpenedRecommendedModal"
/>
